import React, {useContext} from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import ReviseTextButton from "../../../../../components/revise-text/revise-text-button.jsx";
import FormField from "../../../../../components/react-hook-form/form-field.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import {BoFormContext} from "../context/bo-form-context.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaFileSignature} from "react-icons/fa";
import InputFile from "../../../../../components/input/input-file.jsx";
import {useFormContext} from "react-hook-form";
import userService from "../../../../../services/web/user-service.js";
import projectUtils from "../../../../../utils/project-utils.js";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const MySwal = withReactContent(Swal);
const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const BoFormGcmSignature = () => {
    const {setIsLoading} = useContext(BoFormContext);
    const {  setValue } = useFormContext();

    const addSignature = () => {
        userService.getSignatureDefault()
            .then((data) => {
                if (!data) {
                    projectUtils.swalErrorMessage("", "Usuário não possui assinatura cadastrada.", "Ok")
                    return
                }

                MySwal.fire({
                    title: "Confirmar assinatura?",
                    imageUrl: API_KEEPER + "/ged/attach/" + data.id,
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    confirmButtonColor: '#063A6C',
                    cancelButtonColor: '#c10007',
                    reverseButtons: true
                })
                    .then(async ({isConfirmed}) => {
                        if (!isConfirmed) return;

                        const response = await fetch(`${API_URL}/attach/${data.id}`);
                        const image = await response.blob();

                        const file = new Blob([image], {type: image.type});

                        const signature = {
                            "name": data.name,
                            "size": data.size,
                            "attachId": data.id,
                            "extension": data.extension,
                            "file": new File([file], data.id, {type: image.type})
                        }

                        setValue("gcmReportSignature", signature);
                    });
            })
            .catch((error) => {
                console.error(error)
                projectUtils.swalErrorMessage("", "Não foi possível obter a assinatura do agente.")
            })
    }

    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Relatório do agente</Card.Title>
                </Card.Header>

                <Card.Body className={"space-y-4"}>
                    <FormField
                        as={InputTextarea}
                        name={"gcmReport"}
                        label={"Descrição *"}
                        textAreaClass={"h-40"}
                    />

                    <section className={"flex justify-between"}>
                        <FormField
                            name={"gcmReport"}
                            customRender={field => (
                                <ReviseTextButton
                                    value={field.value}
                                    setValue={(value) => field.onChange(value ?? null)}
                                    setIsLoading={setIsLoading}
                                />
                            )}
                        />

                        <FormField
                            name={"gcmReportSignature"}
                            customRender={field => {
                                if (!field.value) {
                                    return (
                                        <Button target={"primary"} onClick={addSignature}>
                                            <FaFileSignature /> Incluir assinatura
                                        </Button>
                                    )
                                }

                                return (
                                    <InputFile
                                        file={{...field.value, type: "image/jpg"}}
                                        removeFile={() => setValue("gcmReportSignature", undefined)}
                                        titleWithFile={"Visualizar assinatura"}
                                    />
                                )
                            }}
                        />
                    </section>
                </Card.Body>
            </Card>
        </>
    );
};

export default BoFormGcmSignature;